/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  GetAIAssistantReceptionViewResponse,
  GetAIAssistantReceptionViewResponseFromJSON,
  GetAIAssistantReceptionViewResponseToJSON,
  PatchCounselingAIAssistantReceptionRequestBody,
  PatchCounselingAIAssistantReceptionRequestBodyFromJSON,
  PatchCounselingAIAssistantReceptionRequestBodyToJSON,
  PharmacyCounselorAIAssistantReception,
  PharmacyCounselorAIAssistantReceptionFromJSON,
  PharmacyCounselorAIAssistantReceptionToJSON,
} from "../models";

export interface GetAIAssistantReceptionViewRequest {
  counselingAiAssistantReceptionId: number;
}

export interface PatchCounselingAIAssistantReceptionRequest {
  counselingId: number;
  patchCounselingAIAssistantReceptionRequestBody: PatchCounselingAIAssistantReceptionRequestBody;
}

/**
 *
 */
export class CounselingAiAssistantReceptionApi extends runtime.BaseAPI {
  /**
   * Get AI assistant reception view
   */
  async getAIAssistantReceptionViewRaw(
    requestParameters: GetAIAssistantReceptionViewRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<GetAIAssistantReceptionViewResponse>> {
    if (
      requestParameters.counselingAiAssistantReceptionId === null ||
      requestParameters.counselingAiAssistantReceptionId === undefined
    ) {
      throw new runtime.RequiredError(
        "counselingAiAssistantReceptionId",
        "Required parameter requestParameters.counselingAiAssistantReceptionId was null or undefined when calling getAIAssistantReceptionView."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counseling-ai-assistant-receptions/{counseling_ai_assistant_reception_id}/view`.replace(
          `{${"counseling_ai_assistant_reception_id"}}`,
          encodeURIComponent(String(requestParameters.counselingAiAssistantReceptionId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => GetAIAssistantReceptionViewResponseFromJSON(jsonValue));
  }

  /**
   * Get AI assistant reception view
   */
  async getAIAssistantReceptionView(
    requestParameters: GetAIAssistantReceptionViewRequest,
    initOverrides?: RequestInit
  ): Promise<GetAIAssistantReceptionViewResponse> {
    return promiseRetry(
      (retry) =>
        this.getAIAssistantReceptionViewRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Update counseling AI assistant reception information
   */
  async patchCounselingAIAssistantReceptionRaw(
    requestParameters: PatchCounselingAIAssistantReceptionRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyCounselorAIAssistantReception>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling patchCounselingAIAssistantReception."
      );
    }

    if (
      requestParameters.patchCounselingAIAssistantReceptionRequestBody === null ||
      requestParameters.patchCounselingAIAssistantReceptionRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "patchCounselingAIAssistantReceptionRequestBody",
        "Required parameter requestParameters.patchCounselingAIAssistantReceptionRequestBody was null or undefined when calling patchCounselingAIAssistantReception."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/counseling-ai-assistant-receptions`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PatchCounselingAIAssistantReceptionRequestBodyToJSON(
          requestParameters.patchCounselingAIAssistantReceptionRequestBody
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PharmacyCounselorAIAssistantReceptionFromJSON(jsonValue)
    );
  }

  /**
   * Update counseling AI assistant reception information
   */
  async patchCounselingAIAssistantReception(
    requestParameters: PatchCounselingAIAssistantReceptionRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyCounselorAIAssistantReception> {
    return promiseRetry(
      (retry) =>
        this.patchCounselingAIAssistantReceptionRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
